<div [ngClass]="tabGroupClasses" [style.--selected-tab-index]="selectedIndex" [style.--total-tabs-quantity]="tabs.length">
    <div class="tab-group__indicator"></div>

    <button
        *ngFor="let tab of tabs; trackBy: trackByTab"
        type="button"
        class="tab-group__item"
        [ngClass]="{ 'tab-group__item--active': selectedTab === tab }"
        (click)="onTabSelect(tab)"
    >
        {{ tab }}
    </button>
</div>
